import { Breadcrumbs, HorizontalLinkGroup } from 'components/navigation';
import { useUserHasAccess } from 'hooks/useUserHasAccess';
import PropTypes from 'prop-types';
import React, { Fragment, useMemo } from 'react';

export function PoliciesLayout(props) {

    const userHasAccess = useUserHasAccess();

    const routes = useMemo(() => {
        return [            
            { location: "/policy-management/policies", title: "Policies", permission: "Documents:Manage" },
            { location: "/policy-management/policies-signoff", title: "Policy Sign-off", permission: "Documents:Manage" },            
        ]
            .filter(r => !r.permission || userHasAccess(r.permission))
    }, [props.defaultPath, userHasAccess]);

    return (
        <Fragment>
            <div className="row">

                <Breadcrumbs items={props.breadcrumbs} />

                <h1>Policies</h1>
            </div>

            <div className="row">
                <div className="spacer-bottom-medium">
                    <HorizontalLinkGroup links={routes} exactRouteMatch={true}></HorizontalLinkGroup>
                </div>
            </div>

            <div className='row'>
                {props.children}
            </div>
        </Fragment>
    );
}

PoliciesLayout.propTypes = {
    breadcrumbs: PropTypes.array,
    defaultPath: PropTypes.string.isRequired,
    children: PropTypes.node
};
